import api from './api';

export type DealerOverview = {
  dealer: { name: string; isVerified: boolean };
  kpis: {
    totalInventory: number;
    activeInventory: number;
    totalLeads: number;
    leadsThisMonth: number;
    leadsPreviousMonth: number;
    totalListingViews: number;
    salesThisMonth?: number | string;
    salesRevenue?: string;
    profileViews?: number | string;
  };
  monthlyLeads: { month: string; leads: number }[];
  recentInventory: {
    id: string;
    title: string;
    price: number | null;
    isActive: boolean;
    views: number;
    leads: number;
    image: string | null;
    createdOn: string;
  }[];
  recentLeads: {
    id: string;
    buyerName: string;
    vehicleTitle: string;
    leadSource: string;
    status: string;
    createdAt: string;
  }[];
};

export const getDealerOverview = async (): Promise<DealerOverview> => {
  const response = await api.get('/dealer/overview');
  return response.data.data;
};
